import * as React from "react";
import { White } from "tp/shared/common-design/colors";

interface DeviationListHeaderProps {
    children: React.ReactNode
}

export const DeviationListHeader = ({ children }: DeviationListHeaderProps): React.ReactElement => (
    <span className="deviation-stamp-message" style={{ color: White }}>
        {children}
    </span>);